<template>
  <div ref="myChart" class="chart"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: "",
    };
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        let data = ["0", "0.1", "0.2", "0.3", "0.4", "0.5"];
        let data2 = [0, -0.18, 0.18, -0.18, 0.18, -0.18, 0.18];

        let option = {
          grid: {
            left: "16%",
          },
          legend: {
            data: ["初级绕组中的电流（A）"],
            textStyle: {
              color: "#fff",
            },
            top: "5%",
          },
          textStyle: {
            color: "#a0e3ff",
          },
          xAxis: {
            boundaryGap: false, // 不留空隙
            type: "category",
            splitLine: {
              show: false,
            },
            data: data,
          },
          yAxis: [
            {
              type: "value",
              name: "初级绕组中的电流（A）",
              splitLine: {
                show: false,
              },
              nameLocation: "middle",
              nameGap: 40,
            },
          ],
          series: [
            {
              name: "初级绕组中的电流（A）",
              type: "line",
              color: "#5470C6",
              symbol: "none",
              smooth: true,
              yAxisIndex: 0,
              data: data2,
            },
          ],
        };

        if (this.myChart) echarts.dispose(this.myChart);
        this.myChart = echarts.init(this.$refs.myChart);
        this.myChart.setOption(option);
      });
    },
  },
  mounted() {
    this.initChart();
  },
};
</script>

<style scoped>
.chart {
  height: 100%;
  width: 100%;
}
</style>
